<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="6" class="pb-0">
        <gg-input-label>Path</gg-input-label>
        <v-text-field
          v-model="path"
          class="gg-input gg-prepend"
          outlined
          ref="pathField"
          dense
          autocomplete="off"
          name="Path"
        >
          <template v-slot:prepend-inner>
            <div class="prepend-bg">
              <domain-select
                no-label
                hide-details
                flat
                solo
                v-model="domain"
                :style="{ minWidth: '180px', width: `${domainWidth}px`, maxWidth: `250px` }"
                @domain-type-selected="domainTypeSelected"
              />
            </div>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="pb-0">
        <gg-input-label>
          Auth Name
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="primary" small v-on="on">
                mdi-help-circle
              </v-icon>
            </template>
            <span>This is what will appear on the browser when the password is prompted.</span>
          </v-tooltip>
        </gg-input-label>
        <gg-text-field
          v-model="authname"
          v-validate="'required'"
          data-vv-name="authname"
          data-vv-as="Auth Name"
          :error-messages="errors.collect('authname')"
        />
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-btn :loading="loading" @click="create">Create</gg-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'

export default {
  name: 'CreateProtectedUrl',
  components: {
    DomainSelect
  },
  data () {
    return {
      authname: '',
      path: '',
      domain: '',
      domainType: 'main_domain',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      parentDir: 'protected_urls/parent'
    }),
    dir () {
      const domain = this.domainType === 'main_domain' ? '' : `${this.domain}/`
      return this.parentDir + '/public_html/' + domain + this.path
    },
    domainWidth () {
      const length = this.domain ? this.domain.length : 18
      return length * 12 // 12 px per symbol
    },
  },
  methods: {
    ...mapActions({
      createProtectedUrl: 'protected_urls/createProtectedUrl',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async create () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      const data = {
        authname: this.authname,
        dir: this.dir,
        _username: this.$route.query.user
      }
      this.loading = true
      try {
        await this.createProtectedUrl(data)
        this.reportSuccess(`Protected URL for "${this.domain}" created.`)
        this.$emit('url-created')
        this.reset()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    reset () {
      this.authname = ''
      this.path = ''
    },
    domainTypeSelected (domainType) {
      // this if is for reseller's subaccount hotfix
      if (!domainType) {
        return
      }
      this.domainType = domainType
    }
  }
}
</script>

<style lang="scss">
.gg-input.gg-prepend {
  .v-input__slot {
    padding-left: 0 !important;
  }

  .v-input__prepend-inner {
    margin-top: 0 !important;
  }

  .prepend-bg {
    .v-input__append-inner {
      margin-top: 0 !important;
    }
    .v-input__slot {
      padding-left: 8px !important;
    }
  }
}

.prepend-bg {
  background: #ececec;
  height: calc(100% - 4px);
  border-radius: 3px;

  > div {
    margin-top: 3px !important;
  }
}
</style>
